import * as Sentry from "@sentry/react";

const captureException = (error, options) => {
  // eslint-disable-next-line no-console
  console.error("[Caught: captureException]", error, options);
  if (Sentry) {
    Sentry.captureException(error, options);
  }
};

export default { captureException };
